export default __webpack_public_path__ + "static/media/feature1.52ec31b2.png";